<script setup></script>

<template>
  <main class="layout-default">
    <SeoTemplatePreset>
      <NavigationHeader />
      <slot />
      <FixedBlock class="hide-for-large" />
      <Footer />
    </SeoTemplatePreset>
  </main>
</template>
